import { getSingularityJobResultById } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import sleep from '@/lib/utils/sleep';
import type { JobResult } from '@/types/singularity';

const POLLING_INTERVAL = 2_000;

export default function usePollSingularityJob() {
  const fetchJob = async (id: string) => {
    const data = await getSingularityJobResultById(
      {
        path: { job_id: id },
      },
      wgApi,
    );

    return data;
  };

  const executeJob = async <T>(id: string): Promise<JobResult<T>> => {
    while (true) {
      const result = await fetchJob(id);

      if (result.status === 'SUCCEEDED')
        return result as unknown as JobResult<T>;

      if (result.status === 'FAILED')
        throw new Error('Singularity returned a result with status FAILED');

      await sleep(POLLING_INTERVAL);
    }
  };

  return { executeJob };
}
